<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/BVYsf6/tc-custom/9781770907942.jpg?1734376544187" alt="This image is the cover for the book Little More Free, The Eddie Dougherty Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Little More Free, The Eddie Dougherty Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <b>“Like [Elmore] Leonard, McFetridge is able to convincingly portray flawed figures on both sides of the law” (<i>Publishers Weekly</i>).</b><br/>  <br/> Montreal, Labor Day weekend, 1972. The city is getting ready to host the first game in the legendary Summit Series between Canada and the USSR. Three men set fire to a nightclub and thirty-seven people die. The Museum of Fine Arts is robbed and two million dollars’ worth of paintings are stolen.<br/>  <br/> Against the backdrop of these historic events, Constable Eddie Dougherty discovers the body of a murdered young man on Mount Royal. As he tries to prove he has the stuff to become a detective, he is drawn into the world of American draft dodgers and deserters, class politics, and organized crime . . .<br/>  <br/> “This terrific continuation of the narrative McFetridge began in <i>Black Rock</i> opens with a bang . . . Working with a deceptively simple style that echoes Joseph Wambaugh, McFetridge has delivered an unpredictable mystery, a fine character study, and a vivid snapshot of 1972 Montreal.” —<i>Publishers Weekly</i><br/>  <br/> “Brilliant . . . As a police procedural, <i>A Little More Free</i> is superb. As a sociopolitical human drama, it’s even better—remember to breathe during those final few pages.” —<i>Winnipeg Free Press</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        John McFetridge
      </h2>
      
      <p class="authorDescription body article">John McFetridge first became fascinated with crime when attending a murder trial at age 12 with his police officer brother. After studying writing at Concordia University and the Canadian Film Centre, McFetridge worked on film sets before writing screenplays and five novels, including four in his Toronto series. He lives in Toronto, Ontario, with his family.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      ECW Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?47f70088